export const comments_5519474 = {"data":{"data":[],"links":{}}}